import { render, staticRenderFns } from "./TeamType.vue?vue&type=template&id=7ebec008&scoped=true&"
import script from "./TeamType.vue?vue&type=script&lang=js&"
export * from "./TeamType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebec008",
  null
  
)

export default component.exports